import { useEffect, useState } from "react";

function calc(target) {
  const diff = Math.max(0, target.getTime() - Date.now());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
}

export default function CountdownTimer({ targetIso, compact = false }) {
  const target = new Date(targetIso || "2026-08-01T10:00:00+01:00");
  const [t, setT] = useState(calc(target));

  useEffect(() => {
    const id = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(id);
  }, [targetIso]);

  const items = [
    { label: "days", value: t.days },
    { label: "hrs", value: t.hours },
    { label: "min", value: t.minutes },
    { label: "sec", value: t.seconds },
  ];

  return (
    <div
      data-testid="countdown-timer"
      className={`flex items-center gap-3 ${compact ? "" : "md:gap-4"}`}
    >
      {items.map((it) => (
        <div
          key={it.label}
          className={`flex flex-col items-center justify-center rounded-2xl bg-primary text-primary-foreground ${
            compact ? "w-14 h-14" : "w-16 h-16 md:w-20 md:h-20"
          }`}
        >
          <div className={`font-serif font-semibold tabular-nums ${compact ? "text-xl" : "text-2xl md:text-3xl"}`}>
            {String(it.value).padStart(2, "0")}
          </div>
          <div className="text-[10px] uppercase tracking-widest opacity-80">
            {it.label}
          </div>
        </div>
      ))}
    </div>
  );
}
